import { createContext } from "react";

export type CredentialImportAction = {
  offerId: string;
  pending: boolean;
};

export const ProviderImportContext = createContext<{
  actions: ReadonlyMap<string, CredentialImportAction>;
  onReview: (offerId: string) => void;
  openCatalog: () => void;
  disabled: boolean;
  isOpen: boolean;
} | null>(null);
